import getMe from './getMe';
import resetPasswordRequestEmail from './resetPasswordRequestEmail';
import resetPasswordResetPassword from './resetPasswordResetPassword';
import resetPasswordValidateToken from './resetPasswordValidateToken';
import updateUser from './updateUser';
import userSignUp from './userSignUp';

const UserActions = {
  getMe,
  userSignUp,
  updateUser,
  resetPasswordRequestEmail,
  resetPasswordValidateToken,
  resetPasswordResetPassword,
};

export default UserActions;
